import React, { useEffect } from 'react';
import { Menu, MenuItem, Icon, Table } from 'semantic-ui-react';
import classNames from 'classnames';
import api from '../../api';
import Config from '../../constants/Config';
import styles from './PromotionDetails.module.scss';
import moment from 'moment';
import { calculateEffectiveYears } from '../../utils/calculate-effective-years';

const PromotionDetails = React.memo(() => {
  const [currentSkip, setCurrrentSkip] = React.useState(1);
  const [listObj, setListObj] = React.useState({
    list: [],
    total: 0,
  });

  const init = React.useCallback(() => {
    api
      .getPromotionDetails({
        limit: Config.AONNOUCEMENT_LIMIT,
        skip: currentSkip - 1,
      })
      .then((res) => {
        setListObj({ list: res.item, total: res.total });
      });
  }, [currentSkip]);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className={styles.app}>
      <div className={styles.table}>
        {/* <Input
          value={value}
          onChange={handleFieldChange}
          action={{
            content: '搜索',
          }}
          // onKeyPress={handleKeyPress}
          placeholder="订单编号/付款人ID/推广人ID"
        /> */}
        <Table celled unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2}>订单编号</Table.HeaderCell>
              <Table.HeaderCell width={1}>用户名</Table.HeaderCell>
              <Table.HeaderCell width={1}>购买人数</Table.HeaderCell>
              <Table.HeaderCell width={1}>购买年限</Table.HeaderCell>
              <Table.HeaderCell width={1}>付款金额</Table.HeaderCell>
              <Table.HeaderCell width={1}>佣金金额</Table.HeaderCell>
              <Table.HeaderCell width={2}>支付时间</Table.HeaderCell>
              <Table.HeaderCell width={1}>推广人</Table.HeaderCell>
              <Table.HeaderCell width={1}>推广码</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {!!listObj.list.length &&
              listObj.list.map((item) => (
                <Table.Row key={item.id}>
                  <Table.Cell>{item.id}</Table.Cell>
                  <Table.Cell>{item.creatorUser.username}</Table.Cell>
                  <Table.Cell>{item.buyNumber || '-'}</Table.Cell>
                  <Table.Cell>{calculateEffectiveYears(item)}</Table.Cell>
                  <Table.Cell>{item.promotionAmountAfterDiscount}</Table.Cell>
                  <Table.Cell>
                    {(item.promotionAmountAfterDiscount * item.promotionCommission).toFixed(1)}
                  </Table.Cell>
                  <Table.Cell>
                    {item.createdAt && moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                  </Table.Cell>
                  <Table.Cell>{item.promotionUserId.name}</Table.Cell>
                  <Table.Cell>{item.promotionUserId.promotionCode}</Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="9">
                <Menu floated="right" pagination>
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre <= 1) {
                          return 1;
                        }
                        return pre - 1;
                      });
                    }}
                  >
                    <Icon name="chevron left" />
                  </MenuItem>
                  {Array.from({ length: listObj.total }, (_, index) => (
                    <MenuItem
                      as="a"
                      key={index}
                      className={classNames(index + 1 === currentSkip && styles.menuItemActive)}
                      onClick={() => {
                        setCurrrentSkip(index + 1);
                      }}
                    >
                      {index + 1}
                    </MenuItem>
                  ))}
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre + 1 >= listObj.total) {
                          return listObj.total;
                        }
                        return pre + 1;
                      });
                    }}
                  >
                    <Icon name="chevron right" />
                  </MenuItem>
                </Menu>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    </div>
  );
});

export default PromotionDetails;
